import {
  APP_SETTING_SAVE_PROJECT_PWA_CONFIG_BEGIN,
  APP_SETTING_SAVE_PROJECT_PWA_CONFIG_SUCCESS,
  APP_SETTING_SAVE_PROJECT_PWA_CONFIG_FAILURE,
  APP_SETTING_SAVE_PROJECT_PWA_CONFIG_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function saveProjectPwaConfig(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_SAVE_PROJECT_PWA_CONFIG_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/pwa-config`,
        args.data,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: APP_SETTING_SAVE_PROJECT_PWA_CONFIG_SUCCESS,
              data: res.data,
            });
            if (args.isNew) {
              toast.success('Added Successfully !', {});
            } else {
              toast.success('Updated Successfully !', {});
            }
            resolve(res.data);
          } else {
            dispatch({
              type: APP_SETTING_SAVE_PROJECT_PWA_CONFIG_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: APP_SETTING_SAVE_PROJECT_PWA_CONFIG_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissSaveProjectPwaConfigError() {
  return {
    type: APP_SETTING_SAVE_PROJECT_PWA_CONFIG_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_SAVE_PROJECT_PWA_CONFIG_BEGIN:
      return {
        ...state,
        saveProjectPwaConfigPending: true,
        saveProjectPwaConfigError: null,
      };

    case APP_SETTING_SAVE_PROJECT_PWA_CONFIG_SUCCESS:
      return {
        ...state,
        saveProjectPwaConfigPending: false,
        saveProjectPwaConfigError: null,
        projectDetail: action.data,
      };

    case APP_SETTING_SAVE_PROJECT_PWA_CONFIG_FAILURE:
      return {
        ...state,
        saveProjectPwaConfigPending: false,
        saveProjectPwaConfigError: action.data.error,
      };

    case APP_SETTING_SAVE_PROJECT_PWA_CONFIG_DISMISS_ERROR:
      return {
        ...state,
        saveProjectPwaConfigError: null,
      };

    default:
      return state;
  }
}
